module.exports = __webpack_public_path__ + "img/bold-icon delete.9fe58553.svg";